module.exports = __webpack_public_path__ + "img/matImage.cdc49deb.svg";